module.exports = __webpack_public_path__ + "static/media/flagimg.98bc6a56.png";